<template>
  <gg-card>
    <gg-card-header>
      Acquisition Details
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <v-data-table :headers="headers" :items="items" :loading="loading">
            <template v-slot:item.col2="{ item }">
              {{ formatDate(item.col2) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AcquisitionDetails',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      headers: [
        { text: 'Date', value: 'col2' },
        { text: 'Domain Name', value: 'col3' },
        { text: 'Type', value: 'col4' },
        { text: 'CPA', value: 'col5' },
        { text: 'Campaign', value: 'col6' },
      ]
    }
  },
  computed: mapGetters({
    loading: 'affiliates/loadingStatistics'
  }),
  methods: {
    formatDate (val) {
      return val.replace('<center>', '').replace('</center>', '').split(' ')[0]
    }
  }
}
</script>

<style scoped>

</style>
